import { useState, useEffect } from "react";
import { useHiredAgainstAJobQuery } from "../graphql/generated/graphql";

const useHiredAgainstAJob = (jobId: any) => {
  const [matchs, setMatchs]: any = useState(null);
  const { data, loading, error, refetch } = useHiredAgainstAJobQuery({
    variables: {
      jobId: jobId,
    },
    fetchPolicy: "network-only",
  });
  const loadMatches = () => {
    if (!loading && data) {
      // console.log(data.hiredAgainstAJob);
      setMatchs(data.hiredAgainstAJob);
    }
  };

  useEffect(() => {
    loadMatches();
  }, [data]);

  return { matchs, refetch };
};

export default useHiredAgainstAJob;
